import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { registerUserRequest } from '@redux/actions/RegisterActions';

import { withStyles } from '@material-ui/core/styles';
import Logo from '@assets/images/logo.png';
import { Button, TextField, Typography } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { styles } from './styles';

const schema = {
  firstname: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  },
  lastname: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  },
  password2: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  }
};

class RegisterComponent extends Component {
  state = {
    value: '',
    formState: {
      isValid: false,
      values: {},
      touched: {},
      errors: {}
    }
  };

  componentDidMount() {
    this.setState({ token: this.props.match.params.id });
  }

  handleChange = event => {
    const { formState } = this.state;

    const errors = validate(formState.values, schema);

    event.persist();

    this.setState({
      formState: {
        ...formState,
        values: {
          ...formState.values,
          [event.target.name]: event.target.value
        },
        touched: {
          ...formState.touched,
          [event.target.name]: true
        },
        isValid: errors ? false : true,
        errors: errors || {}
      }
    });
  };

  handleLogin = event => {
    const { values } = this.state.formState;
    event.preventDefault();

    //TODO: Remove radio fixed value
    const payload = {
      ...values,
      title: 'Mr.',
      token: this.state.token
    };
    this.props.setUserRegister(payload);
  };

  hasError = field => {
    const { formState } = this.state;
    return formState.touched[field] && formState.errors[field] ? true : false;
  };

  render() {
    const { formState } = this.state;
    const { classes } = this.props;

    return (
      <div className={classes.content}>
        <img alt="Praexo" className={classes.logo} src={Logo} />

        <div className={classes.contentBody}>
          <form className={classes.form} onSubmit={this.handleLogin}>
            <Typography color="initial" variant="h1">
              Register
            </Typography>

            <FormControlLabel control={<Radio />} label="Title" value="title" />
            <TextField
              className={classes.textField}
              error={this.hasError('firstname')}
              fullWidth
              helperText={
                this.hasError('firstname')
                  ? formState.errors.firstname[0]
                  : null
              }
              label="Firstname"
              name="firstname"
              onChange={this.handleChange}
              type="text"
              value={formState.values.firstname || ''}
              variant="outlined"
            />
            <TextField
              className={classes.textField}
              error={this.hasError('lastname')}
              fullWidth
              helperText={
                this.hasError('lastname') ? formState.errors.lastname[0] : null
              }
              label="Lastname"
              name="lastname"
              onChange={this.handleChange}
              type="text"
              value={formState.values.lastname || ''}
              variant="outlined"
            />

            <TextField
              className={classes.textField}
              error={this.hasError('password')}
              fullWidth
              helperText={
                this.hasError('password') ? formState.errors.password[0] : null
              }
              label="Password"
              name="password"
              onChange={this.handleChange}
              type="password"
              value={formState.values.password || ''}
              variant="outlined"
            />
            <TextField
              className={classes.textField}
              error={this.hasError('password2')}
              fullWidth
              helperText={
                this.hasError('password2')
                  ? formState.errors.password2[0]
                  : null
              }
              label="Confirm Password"
              name="password2"
              onChange={this.handleChange}
              type="password2"
              value={formState.values.password2 || ''}
              variant="outlined"
            />
            <Button
              className={classes.signInButton}
              color="primary"
              disabled={!formState.isValid}
              size="large"
              type="submit"
              variant="contained">
              Register
            </Button>
          </form>
        </div>
      </div>
    );
  }
}

RegisterComponent.propTypes = {
  classes: PropTypes.any,
  history: PropTypes.object
};

export const mapStateToProps = state => ({ auth: state.auth });

export const mapDispatchToProps = dispatch => {
  return {
    setUserRegister: payload => dispatch(registerUserRequest(payload))
  };
};

export const Register = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(withRouter(RegisterComponent));

export default Register;
